import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSiteSettings } from '../context/SiteSettingsContext';
import { useLocale } from '../context/LocaleContext';

const PAGE_KEYS = {
  '/': '',
  '/articles': 'nav.articles',
  '/services': 'nav.services',
  '/products': 'nav.products',
  '/about': 'nav.about',
  '/contact': 'nav.contact',
  '/login': 'nav.login',
  '/register': 'nav.register',
  '/user-panel': 'nav.account',
  '/admin-panel': 'nav.admin',
};

const resolvePageKey = (pathname) => {
  if (pathname.startsWith('/reset-password/')) return 'titles.resetPassword';
  if (pathname.startsWith('/user-panel/')) return PAGE_KEYS['/user-panel'];
  if (pathname.startsWith('/products/')) return 'titles.product';
  if (pathname.startsWith('/articles/')) return 'titles.article';
  if (pathname.startsWith('/services/')) return PAGE_KEYS['/services'];
  if (pathname.startsWith('/projects/')) return 'titles.project';
  if (pathname.startsWith('/checkout/')) {
    return pathname === '/checkout/success'
      ? 'titles.paymentSuccess'
      : pathname === '/checkout/failed' ? 'titles.paymentFailed' : 'titles.checkout';
  }
  if (Object.prototype.hasOwnProperty.call(PAGE_KEYS, pathname)) {
    return PAGE_KEYS[pathname];
  }
  return 'titles.notFound';
};

const DocumentTitle = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { locales, locale } = useLocale();
  const { settings } = useSiteSettings();

  useEffect(() => {
    const parts = location.pathname.split('/').filter(Boolean);
    if (locales.some((item) => item.code === parts[0])) parts.shift();
    const normalizedPath = `/${parts.join('/')}`.replace(/\/$/, '') || '/';
    const pageKey = resolvePageKey(normalizedPath);
    const pageTitle = pageKey ? t(pageKey) : '';
    document.title = pageTitle
      ? `${pageTitle} | ${settings.general.siteTitle}`
      : (settings.seo.defaultTitle || settings.general.siteTitle);
  }, [locale.code, locales, location.pathname, settings.general.siteTitle, settings.seo.defaultTitle, t]);

  return null;
};

export default DocumentTitle;
